import { C, FONT, EMAIL_STYLES, emailShell } from 'lib/newsletter-email';

// Renders a table-based email (inline styles, literal colors) for copy-paste into a mail client.
export default function EmailDocument({ preheader, rows }) {
  return (
    <div
      style={{
        margin: 0,
        padding: 0,
        fontFamily: FONT,
        backgroundColor: C.canvas,
      }}
    >
      <style dangerouslySetInnerHTML={{ __html: EMAIL_STYLES }} />
      <div className="newsletter-wrapper" dangerouslySetInnerHTML={{ __html: emailShell({ preheader, rows }) }} />
    </div>
  );
}
